export class GradientConfig {

  

  public static config = {
    layout: (JSON.parse(sessionStorage.getItem('currentUser'))?.organisationId == 1) ? 'vertical':'new-vs-code-similar-nav-bar', // vertical, horizontal, new-vs-code-similar-nav-bar
    subLayout: '', // horizontal-2
    collapseMenu: false,
    layoutType: 'menu-light', // menu-dark, menu-light, dark
    headerBackColor: 'header-blue', // header-blue, header-red, header-purple, header-info, header-dark, header-orenge
    // header-green, header-yellow, header-orchidgreen, header-indigogreen, header-darkgreen, header-darkblue
    rtlLayout: false,
    navFixedLayout: true,
    headerFixedLayout: true,
    boxLayout: false,
  };
}
